module.exports = __webpack_public_path__ + "img/album01_10.fd4e6b30.jpg";